// import { Object } from 'types';
// eslint-disable-next-line
const checkParams = (apiParams: any) =>
  Object.entries(apiParams).every(([key, value]) => {
    if (key === 'warehouse') {
      return value !== undefined || value !== null;
    }

    return value;
  });

export { checkParams };
